import { EntitlementsProject } from '@adsk/alloy-provider';

import ReferencePickerPlugin from '../types/ReferencePickerPlugin';

const isToolAllowed = (
  currentProject: EntitlementsProject,
  toolId: string,
  productId: string | undefined,
) => {
  if (productId) {
    const product = currentProject?.products.find((p) => p.key === productId);
    return product?.tools?.some((tool) => tool.key === toolId);
  } else {
    return currentProject?.products.some((product) =>
      product?.tools?.some((tool) => tool.key === toolId),
    );
  }
};

/**
 * Checks whether plugin can be used in picker according to plugin and current project.
 * @param plugin
 * @param currentProject
 * @param bypassToolIds - list of toolIds that will be ignored
 * @return {boolean}
 */
export const isPluginProductOrToolNotAvailableInEntitlements = ({
  plugin,
  currentProject,
  bypassToolIds,
}: {
  plugin: ReferencePickerPlugin<unknown>;
  currentProject: EntitlementsProject;
  bypassToolIds?: string[];
}) => {
  if (
    bypassToolIds &&
    plugin?.toolId &&
    bypassToolIds?.includes(plugin?.toolId)
  ) {
    return false;
  }

  const productAllowed =
    !plugin?.productId ||
    currentProject?.products.some(
      (product) => product.key === plugin.productId,
    );
  const toolAllowed =
    !plugin?.toolId ||
    isToolAllowed(currentProject, plugin.toolId, plugin?.productId);
  return !productAllowed || !toolAllowed;
};
